<template>
  <div class="trbo-a-powered-by">Powered <bot-icon class="trbo-a-powered-by__icon" /> by
    <a v-if="chatchampLinkClickable" :href="link" class="trbo-a-powered-by__link" target="_blank">trbo</a>
    <span v-else>trbo</span>
  </div>
</template>

<script>
// @flow

import { poweredByURL } from '../../../common/models'

import BotIcon from './BotIcon.vue'

export default {
  components: {
    BotIcon
  },
  props: {
    chatchampLinkClickable: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String,
      default: ''
    }
  },
  computed: {
    link (): string {
      return poweredByURL('Wizard')
    }
  }
}
</script>

<style scoped src="./powered-by.scss" />
